/**
 * Represents a specific edition of the Quran
 */
class QuranEdition {
  constructor(data) {
    this.identifier = data.identifier;
    this.language = data.language;
    this.name = data.name;
    this.englishName = data.englishName;
    this.format = data.format;
    this.type = data.type;
    this.direction = data.language === 'ar' ? 'rtl' : 'ltr';
  }

  // Whether this edition is a Tajweed edition (colored text)
  isTajweed() {
    return this.identifier === 'quran-tajweed';
  }

  // Whether this edition is a translation
  isTranslation() {
    return this.type === 'translation';
  }

  // Whether this edition is a tafsir (commentary)
  isTafsir() {
    return this.type === 'tafsir';
  }

  // Whether this edition is a Quran (main Arabic text)
  isQuran() {
    return this.type === 'quran';
  }

  // Whether this edition is a transliteration
  isTransliteration() {
    return this.type === 'transliteration';
  }

  // Add more helpers as needed for future edition types
}

export default QuranEdition;